import { useEffect } from 'react'
import { useLazyRevisitHomeQuery } from 'src/app/appApiQueries'
import { useGetAppContextQuery, zoomSdkApi } from 'src/app/zoomSdkQueries'
import { getS3Link } from 'src/utils/helpers'

export const useRevisitHome = () => {
  const { data: runningContext } = zoomSdkApi.endpoints.config.useQueryState(
    'config',
    {
      selectFromResult: (result) => ({ data: result?.data?.runningContext }),
    }
  )
  const { isLoading: appContextLoading, data = { context: '' } } =
    useGetAppContextQuery('getAppContext')
  const [revisitHome] = useLazyRevisitHomeQuery()
  const isMissingS3Link = !Boolean(getS3Link())
  const isMeeting = runningContext === 'inMeeting'
  const needsHomeRevisit = !appContextLoading && isMissingS3Link && isMeeting

  useEffect(() => {
    if (needsHomeRevisit && data.context) {
      revisitHome(data.context)
    }
  }, [needsHomeRevisit, appContextLoading, data.context, revisitHome])

  return needsHomeRevisit
}
